<template>
  <div>

    <div class="firstaccess-container" v-if="firstAccess">
      <div class="home-container" @click="closeAllPanels">
        <transition name="fade">
          <img src="@/assets/homepage/1s.jpg" class="cover-image" v-if="img1Visible">
        </transition>
        <transition name="fade">
          <img src="@/assets/homepage/2s.jpg" class="cover-image" v-if="img2Visible">
        </transition>
        <transition name="fade">
          <img src="@/assets/homepage/3s.jpg" class="cover-image" v-if="img3Visible">
        </transition>
        <transition name="fade">
          <img src="@/assets/homepage/4s.jpg" class="cover-image" v-if="img4Visible">
        </transition>
        <transition name="fade">
          <img src="@/assets/homepage/5s.jpg" class="cover-image" v-if="img5Visible">
        </transition>
        <transition name="fade">
          <img src="@/assets/homepage/6s.jpg" class="cover-image" v-if="img6Visible">
        </transition>
        <img src="@/assets/home_logo.png">
        <div class="text-container">
          <p>Un progetto dell'Archivio Cinescatti di Lab 80 film: per esplorare volti e luoghi attraverso i film
            amatoriali
            e di famiglia. Sulla mappa trovi tutte le raccolte territoriali realizzate da Cinescatti in regione
            Lombardia.
            Ogni film è stato posizionato nell’esatto luogo in cui è stato girato: per riscoprire la storia del
            territorio
            attraverso lo sguardo inedito di chi ne è stato diretto testimone.</p>
        </div>
        <h2>ENTRA</h2>
      </div>
    </div>

    <GlobalEvents @keydown.esc="closeAllPanels"/>

    <div class="watermark" v-if="!firstAccess && !videoPanelIsOpen">
      <img src="@/assets/watermark.png">
    </div>

    <div :class="[sideMenuIsOpen ? 'isOpen' : '', $mq === 'sm' ? 'panel-wrap-sm' : 'panel-wrap']" v-if="!firstAccess">
      <div class="panel">
        <ul>
          <li @click="toggleCollectionsPanel" v-tooltip.left-center="'Filtra per raccolta'">
            <vue-material-icon name="reorder" :size="32"/>
          </li>
          <li @click="toggleYearsPanel" v-tooltip.left-center="'Filtra per anni'">
            <vue-material-icon name="search" :size="32"/>
          </li>
          <li @click="toggleHelpPanel" v-tooltip.left-center="'Più informazioni'">
            <vue-material-icon name="info" :size="32"/>
          </li>
        </ul>
      </div>
    </div>

    <PanelYears :selectable-years="selectableYears" @select-year="setSelectedYear" :is-open="yearsMenuIsOpen"
                :selected-year="selectedYear"/>
    <PanelCollections :collections="collections" :collection-active="collectionActive"
                      @select-collection="setSelectedCollection" :is-open="collectionsMenuIsOpen"/>
    <PanelHelp :is-open="helpMenuIsOpen"/>

    <GmapMap
      id="map_canvas"
      :center="center"
      :zoom="6"
      ref="mapRef"
      map-type-id="roadmap"
      :options="options"
      @click="closeAllPanels">

      <GmapInfoWindow :options="infoOptions" :position="infoWindowPos" :opened="infoWinOpen">
        <h3>{{ iwTitle }}</h3>
      </GmapInfoWindow>

      <GmapMarker
        v-for="(marker) in markersVisible"
        :position="marker.position"
        :draggable="false"
        :key="marker.unique"
        :icon="marker.icon"
        @click="clickOnMarker(marker)"
        @mouseover="openInfoWindow(marker)"
        @mouseout="closeInfoWindow"
      />

    </GmapMap>

    <div class="videopanel-container"
         :class="{ 'is-open': videoPanelIsOpen,'videopanel-container-min-height': this.windowHeight < 500}"
         v-if="videoPanelIsOpen">
      <PanelVideo :sequence="sequenceSelected" @close="closeAllPanels" v-if="videoPanelIsOpen"/>
    </div>

  </div>
</template>

<script>
  // @ is an alias to /src
  import PanelYears from '@/components/PanelYears'
  import MapStyle from '@/assets/MapStyle.js'
  import collections from '../api/collections'
  import uuidv1 from 'uuid'
  import PanelCollections from "@/components/PanelCollections"
  import PanelHelp from "@/components/PanelHelp"
  import PanelVideo from "@/components/PanelVideo"

  export default {
    name: 'Map',
    data() {
      return {
        img1Visible: true,
        img2Visible: false,
        img3Visible: false,
        img4Visible: false,
        img5Visible: false,
        img6Visible: false,
        imageTimeout: null,
        firstAccess: false,
        collections: [],
        collectionActive:
          null,
        markersActive:
          [],
        markersVisible:
          [],
        selectableYears:
          [],
        selectedYear:
          null,
        center:
          {
            lat: 45, lng:
              9
          },
        infoWindowPos: null,
        infoWinOpen:
          false,
        currentMidx:
          null,
        //optional: offset infowindow so it visually sits nicely on top of our marker
        infoOptions:
          {
            pixelOffset: {
              width: 0,
              height:
                -50,
              maxWidth:
                200
            }
          }
        ,
        iwTitle: '',
        iwVideo:
          '',
        sideMenuIsOpen:
          true,
        yearsMenuIsOpen:
          false,
        collectionsMenuIsOpen:
          false,
        helpMenuIsOpen:
          false,
        videoPanelIsOpen:
          false,
        sequenceSelected:
          {}
      }
    },
    beforeCreate() {

    },
    mounted() {
      this.imageSlider()
      if (this.$route.params.id === undefined) {
        this.firstAccess = true
      }
      collections.get().then((response) => {
        this.collections = response.data.data
        this.setMarkersActive(this.collections)
      })
    },
    methods: {
      imageSlider() {
        let v = this
        setInterval(() => {
          if (v.img1Visible) {
            v.img1Visible = false
            v.img2Visible = true
            v.img3Visible = false
            v.img4Visible = false
            v.img5Visible = false
            v.img6Visible = false
          } else if (v.img2Visible) {
            v.img1Visible = false
            v.img2Visible = false
            v.img3Visible = true
            v.img4Visible = false
            v.img5Visible = false
            v.img6Visible = false
          } else if (v.img3Visible) {
            v.img1Visible = false
            v.img2Visible = false
            v.img3Visible = false
            v.img4Visible = true
            v.img5Visible = false
            v.img6Visible = false
          } else if (v.img4Visible) {
            v.img1Visible = false
            v.img2Visible = false
            v.img3Visible = false
            v.img4Visible = false
            v.img5Visible = true
            v.img6Visible = false
          } else if (v.img5Visible) {
            v.img1Visible = false
            v.img2Visible = false
            v.img3Visible = false
            v.img4Visible = false
            v.img5Visible = false
            v.img6Visible = true
          } else if (v.img6Visible) {
            v.img1Visible = true
            v.img2Visible = false
            v.img3Visible = false
            v.img4Visible = false
            v.img5Visible = false
            v.img6Visible = false
          }
        }, 4000)
      },
      setSelectableYears() {
        this.selectedYear = null
        this.selectableYears = []
        let reelYears = []
        this.markersActive.forEach((value) => {
          if (value.anno_inizio !== null) {
            reelYears.push(value.anno_inizio)
          }
        })
        reelYears.sort()
        let min = reelYears[0]
        let max = reelYears[reelYears.length - 1]
        while (min === min) {
          if (min % 10 === 0) {
            break
          }
          min--
        }
        while (max === max) {
          if (max % 10 === 0) {
            break
          }
          max++
        }
        while (min !== max) {
          this.selectableYears.push(min)
          min += 10
        }

      },
      setMarkersActive(collections) {
        this.markersActive = []
        this.$refs.mapRef.$mapPromise.then((map) => {
          this.zoomControlOptions = {
            position: window.google.maps.ControlPosition.LEFT_CENTER
          }
          let bounds = new window.google.maps.LatLngBounds()
          collections.forEach((collection) => {
            collection.sequences.data.forEach((sequence) => {
              sequence.unique = uuidv1()
              sequence.icon = collection.marker
              sequence.position = {lat: sequence.lat, lng: sequence.lng}
              bounds.extend(sequence.position)
              this.markersActive.push(sequence)
            })
          })
          map.fitBounds(bounds)
        }).then(() => {
          this.markersVisible = this.markersActive
          this.setSelectableYears()
          if (this.$route.params.id !== undefined) {
            this.openVideoBox(parseInt(this.$route.params.id))
          }
        })
      },
      setSelectedYear(year) {
        this.selectedYear = year
        this.yearsMenuIsOpen = this.$mq !== 'sm'
      },
      setSelectedCollection(collection) {
        this.collectionActive = collection
        this.setMarkersActive([collection])
      },
      openInfoWindow(marker) {
        this.infoWindowPos = marker.position
        this.iwTitle = marker.titolo
        this.iwVideo = marker.video
        //check if its the same marker that was selected if yes toggle
        if (this.currentMidx === marker.unique) {
          this.infoWinOpen = !this.infoWinOpen
        }
        //if different marker set infowindow to open and reset current marker index
        else {
          this.infoWinOpen = true
          this.currentMidx = marker.unique
        }
      },
      closeInfoWindow() {
        this.infoWinOpen = false
      },
      clickOnMarker(marker) {
        this.videoPanelIsOpen = false
        this.helpMenuIsOpen = false
        this.yearsMenuIsOpen = false
        this.collectionsMenuIsOpen = false
        const id = marker.id
        this.$router.push({name: 'map', params: {id}})
      },
      openVideoBox(id) {
        this.sequenceSelected = this.markersActive.filter((value) => {
          return value.id === id
        })[0]
        this.videoPanelIsOpen = true
      },
      toggleCollectionsPanel() {
        this.helpMenuIsOpen = false
        this.yearsMenuIsOpen = false
        this.collectionsMenuIsOpen = !this.collectionsMenuIsOpen
      },
      toggleYearsPanel() {
        this.helpMenuIsOpen = false
        this.collectionsMenuIsOpen = false
        this.yearsMenuIsOpen = !this.yearsMenuIsOpen
      },
      toggleHelpPanel() {
        this.yearsMenuIsOpen = false
        this.collectionsMenuIsOpen = false
        this.helpMenuIsOpen = !this.helpMenuIsOpen
      },
      closeAllPanels() {
        if (this.firstAccess) {
          this.firstAccess = false
          return
        }
        this.videoPanelIsOpen = false
        this.helpMenuIsOpen = false
        this.yearsMenuIsOpen = false
        this.collectionsMenuIsOpen = false
        if (this.$router.currentRoute.fullPath !== '/') {
          this.$router.push({name: 'map'})
        }
      },
    },
    beforeRouteUpdate(to, from, next) {
      const id = to.params.id
      if (id !== undefined) {
        this.openVideoBox(to.params.id)
      } else {
        this.videoPanelIsOpen = false
      }
      next()
    },
    watch: {
      selectedYear: function (year) {
        this.markersVisible = this.markersActive.filter((sequence) => {
          if (year === null) return true
          let max = year + 9
          return sequence.anno_inizio >= year && sequence.anno_inizio <= max
        })
        if (this.markersVisible.length > 0) {
          let bounds = new window.google.maps.LatLngBounds()
          this.markersVisible.forEach((marker) => {
            bounds.extend(marker.position)
          })
          this.$refs.mapRef.fitBounds(bounds)
        }
      }
    },
    computed: {
      options() {
        let position = 4
        if (this.windowHeight < 366) {
          position = 6
        }
        return {
          zoomControl: true,
          zoomControlOptions: {
            position: position
          },
          mapTypeControl:
            false,
          scaleControl:
            false,
          streetViewControl:
            false,
          rotateControl:
            false,
          fullscreenControl:
            false,
          disableDefaultUi:
            false,
          styles:
          MapStyle
        }
      }
    },
    components: {
      PanelVideo,
      PanelHelp,
      PanelCollections,
      PanelYears
    }
  }
</script>

<style lang="scss">

  @import "../styles/variables";

  .firstaccess-container {
    display: flex;
    flex-direction: row;
    justify-content: center;
    cursor: pointer;

    .home-container {
      background-size: cover;
      background-repeat: repeat-y;
      background-color: rgb(255, 255, 255);
      z-index: 20;
      flex-grow: 1;
      display: flex;
      flex-direction: column;
      justify-content: center;
      align-items: center;
      color: $red;
      position: absolute;
      width: 100% !important;
      height: 100% !important;
      object-fit: cover;
      top: 0;

      @media (min-width: 1200px) {
        img {
          width: 40vw;
        }
        p {
          width: 40vw;
          font-size: 1vw;
        }
        h2 {
          font-size: 30px;
        }
      }

      @media (min-width: 768px) and (max-width: 1200px) {
        img {
          width: 60vw;
        }
        p {
          width: 60vw;
          font-size: 2vw;
        }
        h2 {
          font-size: 30px;
        }
      }

      @media (max-width: 768px) {
        img {
          width: 80vw;
        }
        p {
          width: 80vw;
          font-size: 4vw;
        }
        h2 {
          font-size: 20px;
        }
      }

      .text-container {
        width: 100%;
        background-color: rgba(0, 0, 0, .49);
        padding-top: 10px;
        padding-bottom: 10px;
        margin-bottom: 10px;
      }

      p {
        color: white;
        text-align: justify;
        margin: 0 auto;
      }

      h2 {
        margin-bottom: 0px;
        margin-top: 1px;
        color: white;
      }

      h1 {
        margin-top: 0px;
        font-size: 65px;
        line-height: 0.6;
        margin-bottom: 10px;
      }

      span {
        color: black;
        font-size: 11px;
      }
    }
  }

  .cover-image {
    position: absolute;
    z-index: -1;
    width: 100% !important;
    height: 100% !important;
    object-fit: cover;
    top: 0;
  }

  .fade-enter-active, .fade-leave-active {
    transition: opacity .5s;
  }

  .fade-enter, .fade-leave-to /* .fade-leave-active below version 2.1.8 */
  {
    opacity: 0;
  }

  .watermark {
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
    position: fixed;
    top: 20px;
    left: 20px;
    z-index: 1;

    img {
      width: 125px;
    }

    h2 {
      margin-bottom: 0px;
      font-size: 15px;
      margin-top: 5px;
    }

    h1 {
      margin-top: 0px;
      font-size: 25px;
      line-height: 0.6;
      margin-bottom: 10px;
    }
  }

  .videopanel-container {
    display: flex;
    flex-direction: row;
    justify-content: center;
    align-items: stretch;
    height: 100vh;
    transform: translateY(-100%);
    background: rgba(0, 0, 0, 0.0);
    transition: transform .2s ease-in-out, background-color .4s .2s;

    &.is-open {
      transform: translateY(0);
      background-color: rgba(0, 0, 0, 0.7);
    }
  }

  .videopanel-container-min-height {
    height: 100%;
  }

  #map_canvas {
    width: 100%;
    height: 100%;
    position: absolute;
    top: 0;
    left: 0;
    z-index: 0;

    h3 {
      color: $red;
    }
  }

  .panel-wrap {
    position: fixed;
    top: 0;
    bottom: 0;
    right: 0;
    width: 70px;
    transform: translateX(100%);
    transition: .3s ease-out;
    z-index: 11;

    &.isOpen {
      transform: translateX(0%);
    }

    .panel {
      position: absolute;
      top: 0;
      bottom: 0;
      left: 0;
      right: 0;
      background: $red;
      color: #eee;
      opacity: .9;
      overflow: auto;
      padding: 1em;

      ul {
        backface-visibility: hidden;
        list-style: none;
        margin: 0;
        padding: 0;
        width: 100%;
        overflow: visible;
        height: 210px;
        position: absolute;
        top: 50%;
        margin-top: -105px;
        right: 0px;
        text-align: center;

        li {
          padding-top: 10px;
          display: block;
          position: relative;
          width: 70px;
          height: 70px;
          cursor: pointer;

          .material-icon {
            background-color: white;
            color: $red;
            border-radius: 60px;
            padding: 6px;
            opacity: .8;
          }

          .material-icon:hover {
            opacity: 1;
          }
        }
      }
    }
  }

  .panel-wrap-sm {
    position: fixed;
    left: 0;
    bottom: 0;
    right: 0;
    height: 70px;
    background: $red;
    transform: translateX(100%);
    transition: .3s ease-out;
    z-index: 11;

    &.isOpen {
      transform: translateX(0%);
    }

    ul {
      display: flex;
      flex-direction: row;
      justify-content: center;
      backface-visibility: hidden;
      list-style: none;
      margin: 0;
      padding: 0;
      width: 100%;
      overflow: visible;
      height: 70px;
      bottom: 0;
      text-align: center;

      li {
        padding-top: 10px;
        display: block;
        position: relative;
        width: 70px;
        height: 70px;
        cursor: pointer;
        float: left;

        .material-icon {
          background-color: white;
          color: $red;
          border-radius: 60px;
          padding: 6px;
          opacity: .8;
        }

        .material-icon:hover {
          opacity: 1;
        }
      }
    }
  }

  .panel-side {
    position: fixed;
    top: 0;
    bottom: 0;
    right: 0;
    width: 500px;
    transform: translateX(100%);
    transition: .2s ease-in-out;
    z-index: 10;

    &.is-open {
      transform: translateX(0%);
    }

    .panel {
      position: absolute;
      top: 0;
      bottom: 0;
      left: 0;
      right: 0;
      background: #fff;
      overflow: auto;
      padding: 1em;

      ul {
        backface-visibility: hidden;
        list-style: none;
        margin: 0;
        padding: 0;
        width: 100%;
        overflow: visible;
        right: 0px;

        li {
          padding-top: 10px;
          border-bottom: 1px solid $border-color;
          display: block;
          position: relative;
          width: 400px;
          height: 35px;
          cursor: pointer;

          span {
            font-size: 18px;
            font-weight: bold;
            color: $gray;
          }

          .menu-icon {
            float: right;

            span {
              font-weight: normal;
              color: $red;
            }
          }
        }
      }
    }
  }

  .panel-side-sm {
    position: fixed;
    top: 0;
    bottom: 0;
    width: 100vw;
    transform: translateX(100%);
    transition: .2s ease-in-out;
    z-index: 10;

    &.is-open {
      transform: translateX(0%);
    }

    .panel {
      top: 0;
      bottom: 0;
      background: #fff;
      color: #000;
      overflow: auto;
      height: 100vh;
      padding: 5px;

      ul {
        backface-visibility: hidden;
        list-style: none;
        margin: 0;
        padding: 0;
        overflow: visible;
        right: 0px;

        li {
          padding-top: 10px;
          border-bottom: 1px solid $border-color;
          display: block;
          position: relative;
          height: 35px;
          cursor: pointer;

          span {
            font-size: 18px;
            font-weight: bold;
            color: $gray;
          }

          .menu-icon {
            float: right;

            span {
              font-weight: normal;
              color: $red;
            }
          }
        }
      }
    }
  }

  .selected {
    font-weight: bold;
  }

  .close {
    text-align: right;

    span {
      cursor: pointer;
    }
  }

</style>
